// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Text } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function PackagingVariant({ packagingVariant, ...rest }) {
  if (!packagingVariant) return null;
  const { eanCase } = packagingVariant;
  if (!eanCase) return null;

  return (
    <Section title={<Trans>Case</Trans>} {...rest}>
      <Text>{eanCase}</Text>
    </Section>
  );
}

export const fragment = graphql`
  fragment PackagingVariant on ProductPackagingVariant {
    eanCase
  }
`;

PackagingVariant.fragment = gql`
  fragment PackagingVariant on ProductPackagingVariant {
    eanCase
  }
`;
